import Component from "../../components/MessageBubble/MessageBubble";
import styles from "../../components/MessageBubble/MessageBubble.styles.scss";
import {useContext, useState} from "preact/hooks";
import {CurrentUserContext} from "../../contexts";
import {removeMessageByModerator} from "../../api";
import Linkify from "../Linkify/Linkify";

const MessageBubble = ({
  roomId,
  message,
  messageId,
  content,
  internalId,
  timestamp,
  readBy = 0,
  senderName,
  senderColor,
  hiddenByModerator = false,
  isAppended = false,
  isOwner = false,
  isSilenced = false,
  onRequestSilenceUser,
  onRequestSearch,
}) => {
  const [isHovering, setHovering] = useState(false);
  const [isMenuVisible, setMenuVisible] = useState(false);
  const currentUser = useContext(CurrentUserContext);

  const onMouseEnter = () => {
    setHovering(true);
  };

  const onMouseLeave = () => {
    setHovering(false);
  };

  const onRequestRemoveMessageByModerator = () => {
    setMenuVisible(false);
    removeMessageByModerator(roomId, messageId).catch(err => {
      alert("Ocorreu um erro ao remover a mensagem. Por favor, entre em contato com o suporte.");
      throw new Error(err);
    });
  };

  const onClickSilenceUser = (minutes) => {
    // TODO: hide menu after clicking, somehow it bugs and the options stop working
    onRequestSilenceUser(internalId, isSilenced, minutes);
  };

  const isModerator = currentUser.is_moderator;

  let options = [{
    label: isSilenced ? "Liberar usuário" : "Silenciar por 30 mins.",
    onClick: () => onClickSilenceUser(30)
  }, isSilenced ? null : {
    label: "Silenciar por 2h",
    onClick: () => onClickSilenceUser(120),
  }, isSilenced ? null : {
    label: "Silenciar por 8h",
    onClick: () => onClickSilenceUser(480),
  }, {
    label: "Apagar mensagem",
    onClick: onRequestRemoveMessageByModerator
  }].filter(opt => opt);



  // TODO: fix the bug that happens that after we delete an user message we can't silence him anymore (the button
  // doesn't work anymore), then we can remove this
  if (hiddenByModerator)
    options = [];

  const linkifyOptions = {
    target: {
      url: '_blank'
    },
    attributes: {
      onClick: evt => {
        const href = evt.target.getAttribute("href");
        if (href.startsWith("#")) {
          evt.preventDefault();
          onRequestSearch(href);
          return true;
        }
      }
    },
    className: styles.linkified,
  };

  return <Component
    message={message}
    content={<Linkify options={linkifyOptions} tagName="span">{content}</Linkify>}
    timestamp={timestamp}
    senderName={senderName}
    senderColor={senderColor}
    readBy={readBy}
    isAppended={isAppended}
    isOwner={isOwner}
    options={options}
    isHovering={isHovering}
    isModerator={isModerator}
    onMouseEnter={onMouseEnter}
    onMouseLeave={onMouseLeave}
    onClickOutsideMenu={() => setMenuVisible(false)}
    isMenuVisible={isMenuVisible}
    onToggleMenu={() => setMenuVisible(!isMenuVisible)}
    hiddenByModerator={hiddenByModerator}
    isSilenced={isSilenced}
  />
};

export default MessageBubble;



// WEBPACK FOOTER //
// ./containers/MessageBubble/MessageBubble.js